/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-alert */
import React, { useState, useEffect } from 'react';
// import { useHistory } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardTitle, Button, Label,
} from 'reactstrap';
import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { Can } from '../../utilities/Can';
import { get, post } from '../../helpers/api_helper';
// import * as url from '../../helpers/url_helper';

import CategoryLayout from '../../components/Listing/CategoryLayout';

function Trees(props) {
  // const history = useHistory();
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [trees, setTrees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showNew, setShowNew] = useState(false);
  const [createIsLoading, setCreateIsLoading] = useState(false);
  const [selectedTree, setSelectedTree] = useState('0');

  const selectTree = (event) => {
    const treeId = event.target.value;
    setError(null);

    // Set the selected tree object in the state
    setSelectedTree(treeId);
  };

  const fetchTrees = async () => {
    const uri = '/api/listings/trees';
    setLoading(true);

    try {
      const obj = await get(uri);
      setTrees(obj.results);

      if (obj.results.length > 0 && selectedTree === '0') {
        setSelectedTree(obj.results[0].id);
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchCat = async () => {
    const uri = '/api/listings/category/14';

    try {
      await get(uri);
    } catch (e) {
      setError(e.message);
    }
  };

  useEffect(() => {
    fetchTrees();

    fetchCat();
  }, []);

  const create = async (values, formProps) => {
    try {
      setCreateIsLoading(true);
      const result = await post('/api/listings/tree/create', values);
      setError(null);

      toastr.success(props.t(`Tree ${result.id} saved`), props.t('Success'));
      fetchTrees();
      setShowNew(false);
      formProps.resetForm();
    } catch (err) {
      setError(`${err.message}: ${err.response.data}`);
    } finally {
      setCreateIsLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    key: Yup
      .string()
      .required(props.t('Key is required'))
      .matches(/^[a-z0-9-]/, props.t('Must be lowercase alphanumerics and hyphens only')),
    description: Yup
      .string()
      .required(props.t('Description is required')),
  });

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="3">
            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('Category Trees')}</CardTitle>

                <Can i="see" this="Trees">
                  {!showNew && (
                    <Button color="primary" size="sm" className="mt-2 mb-3" onClick={() => { setShowNew(!showNew); }}>
                      {props.t('New Tree')}
                      {' '}
                      <span className="mdi mdi-plus-thick" />
                    </Button>
                  )}

                  {showNew && (
                    <Button color="dark" size="sm" className="mt-2 mb-3" onClick={() => { setShowNew(!showNew); }}>
                      {props.t('Nevermind')}
                      {' '}
                      <span className="mdi mdi-close-thick" />
                    </Button>
                  )}

                  {showNew !== false && (
                    <div className="mt-3 mb-3 p-3 bg-soft bg-warning">
                      <Formik
                        enableReinitialize
                        initialValues={{}}
                        validationSchema={ValidationSchema}
                        onSubmit={(values) => {
                          create(values);
                        }}
                      >
                        {({
                          touched, errors,
                        }) => (
                          <Form id="new_tree_form">
                            <Row>
                              <Col sm={4}>
                                <Label for="tree_key">{props.t('Key')}</Label>
                                <Field
                                  type="text"
                                  className={`form-control ${(errors.key && touched.key ? 'is-invalid' : '')}`}
                                  id="tree_key"
                                  name="key"
                                  placeholder="fake-tree"
                                  // eslint-disable-next-line jsx-a11y/no-autofocus
                                  autoFocus
                                />
                                <ErrorMessage
                                  name="key"
                                  component="div"
                                  className="text-danger mt-2"
                                />
                              </Col>
                              <Col sm={8}>
                                <Label for="tree_description">{props.t('Description')}</Label>
                                <Field
                                  type="text"
                                  className={`form-control ${(errors.description && touched.description ? 'is-invalid' : '')}`}
                                  id="tree_description"
                                  name="description"
                                  placeholder="Description of fake tree"
                                />
                                <ErrorMessage
                                  name="description"
                                  component="div"
                                  className="text-danger mt-2"
                                />
                              </Col>
                            </Row>

                            {createIsLoading === true && (
                              <Button type="submit" color="primary" size="sm" className="mt-2" disabled>Creating...</Button>
                            )}
                            {createIsLoading === false && (
                              <Button type="submit" color="primary" size="sm" className="mt-2">Create</Button>
                            )}
                          </Form>
                        )}
                      </Formik>
                    </div>
                  )}

                  <div className="mt-3">
                    {error != null && (
                      <div className="alert alert-danger">{error}</div>
                    )}
                    {loading && (
                      <div>
                        <label htmlFor="tree_select">{props.t('Select a tree')}</label>
                        <select label="Select a Tree" id="tree_select" className="form-control" disabled>
                          <option>Loading...</option>
                        </select>
                      </div>
                    )}
                    {!loading && Trees.length > 0 && (
                      <div>
                        <label htmlFor="tree_select">{props.t('Select a tree')}</label>
                        <select label="Select a Tree" id="tree_select" className="form-control" onChange={selectTree}>
                          {trees.map((x) => (
                            <option value={x.id} key={`tree_${x.id}`}>{`${x.key} - ${x.description}`}</option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>
                </Can>

                <Can not i="see" this="Listings"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>

          <Col xl="7">
            {selectedTree !== '0' && error === null && (
              <Card>
                <CardBody>
                  <CategoryLayout treeId={parseInt(selectedTree, 10)} />
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
}

Trees.defaultProps = {
  t: (x) => (x),
};

Trees.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Trees));
